(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESKTOP_SCROLL_QUERY = window.matchMedia('(min-width: 990px)');

  function getScroller() {
    if (DESKTOP_SCROLL_QUERY.matches) {
      return document.querySelector('.page-wrapper') || window;
    }
    return window;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function waitForGsap(fn, attempts) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      fn();
      return;
    }
    if ((attempts || 0) > 100) return;
    setTimeout(function () {
      waitForGsap(fn, (attempts || 0) + 1);
    }, 50);
  }

  function setProgressState(numbers, progress) {
    var stepIndex = progress < 0.33 ? 0 : progress < 0.66 ? 1 : 2;
    numbers.forEach(function (num, i) {
      num.classList.toggle('is-complete', i < stepIndex);
      num.classList.toggle('is-current', i === stepIndex);
    });
  }

  function killPanelTriggers(panel) {
    if (typeof ScrollTrigger === 'undefined') return;
    ScrollTrigger.getAll().forEach(function (trigger) {
      if (trigger.trigger && (trigger.trigger === panel || panel.contains(trigger.trigger))) {
        trigger.kill();
      }
    });
  }

  function resetPanelSteps(panel) {
    panel.querySelectorAll('.lpo-hiw-scroll__step-inner').forEach(function (step) {
      if (typeof gsap !== 'undefined') {
        gsap.set(step, { clearProps: 'transform,opacity,visibility' });
      } else {
        step.style.transform = '';
        step.style.opacity = '';
        step.style.visibility = '';
      }
    });
  }

  function scrollTriggerBase(panel) {
    return {
      trigger: panel,
      scroller: getScroller(),
      start: 'top top',
      end: 'bottom bottom',
      invalidateOnRefresh: true
    };
  }

  function initPanelAnimations(panel) {
    killPanelTriggers(panel);
    resetPanelSteps(panel);

    if (
      reduceMotion ||
      !DESKTOP_SCROLL_QUERY.matches ||
      typeof gsap === 'undefined' ||
      typeof ScrollTrigger === 'undefined'
    ) {
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var progress = panel.querySelector('[data-lpo-hiw-progress]');
    var progressLine = panel.querySelector('[data-lpo-hiw-progress-line]');
    var numbers = panel.querySelectorAll('[data-lpo-hiw-progress-num]');
    var steps = panel.querySelectorAll('.lpo-hiw-scroll__step-inner');
    var scroller = getScroller();

    if (progressLine && numbers.length) {
      gsap.set(progressLine, { width: '0%' });

      gsap
        .timeline({
          scrollTrigger: Object.assign({}, scrollTriggerBase(panel), { scrub: 1 })
        })
        .to(progressLine, { width: '100%', duration: 1, ease: 'none' });

      ScrollTrigger.create(
        Object.assign({}, scrollTriggerBase(panel), {
          scrub: 1,
          onUpdate: function (self) {
            setProgressState(numbers, self.progress);
            if (progress) {
              progress.classList.toggle('is-hidden', self.progress > 0.95);
            }
          }
        })
      );
    }

    /*
      Exit previous steps fully (autoAlpha → visibility:hidden at 0)
      so sticky stacking never shows ghosted copy underneath.
    */
    steps.forEach(function (step, index) {
      if (index === steps.length - 1) return;
      gsap
        .timeline({
          scrollTrigger: {
            trigger: panel,
            scroller: scroller,
            start: index === 0 ? '20% top' : '50% top',
            end: index === 0 ? '50% top' : '100% bottom',
            scrub: 1.2,
            invalidateOnRefresh: true
          }
        })
        .to(step, {
          scale: 0.92,
          autoAlpha: 0,
          duration: 1,
          ease: 'none'
        });
    });

    panel.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener(
        'load',
        function () {
          ScrollTrigger.refresh();
        },
        { once: true }
      );
    });

    ScrollTrigger.refresh();
  }

  function initSection(root) {
    if (root.dataset.lpoHiwScrollReady === 'true') return;
    root.dataset.lpoHiwScrollReady = 'true';

    var tablist = root.querySelector('[role="tablist"]');
    var tabToggles = root.querySelectorAll('[data-lpo-hiw-tab]');
    var tabPanels = root.querySelectorAll('[data-lpo-hiw-panel]');

    function activateTab(toggle) {
      if (!toggle) return;
      var key = toggle.getAttribute('data-lpo-hiw-tab');
      tabToggles.forEach(function (btn) {
        var active = btn === toggle;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
        btn.tabIndex = active ? 0 : -1;
      });
      tabPanels.forEach(function (panel) {
        var active = panel.getAttribute('data-lpo-hiw-panel') === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
        if (!active) {
          killPanelTriggers(panel);
          resetPanelSteps(panel);
        }
      });

      var activePanel = root.querySelector('.lpo-hiw-scroll__panel.is-active');
      if (activePanel) {
        requestAnimationFrame(function () {
          initPanelAnimations(activePanel);
          if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
        });
      }
    }

    tabToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        activateTab(toggle);
      });
    });

    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var tabs = Array.prototype.slice.call(tabToggles);
        var current = document.activeElement;
        var i = tabs.indexOf(current);
        if (i < 0) return;
        var next = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next < 0) return;
        e.preventDefault();
        activateTab(tabs[next]);
        tabs[next].focus();
      });
    }

    var activePanel = root.querySelector('.lpo-hiw-scroll__panel.is-active');
    if (activePanel) {
      initPanelAnimations(activePanel);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-lpo-hiw-scroll]').forEach(initSection);
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  }

  function refreshAll() {
    document.querySelectorAll('[data-lpo-hiw-scroll]').forEach(function (root) {
      root.dataset.lpoHiwScrollReady = 'false';
      root.querySelectorAll('[data-lpo-hiw-panel]').forEach(function (panel) {
        killPanelTriggers(panel);
        resetPanelSteps(panel);
      });
      initSection(root);
    });
  }

  onReady(function () {
    waitForGsap(initAll);
  });

  window.addEventListener('load', function () {
    waitForGsap(function () {
      if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    });
  });

  DESKTOP_SCROLL_QUERY.addEventListener('change', function () {
    waitForGsap(refreshAll);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lpo-hiw-scroll]');
    if (root) {
      root.dataset.lpoHiwScrollReady = 'false';
      waitForGsap(function () {
        initSection(root);
      });
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-lpo-hiw-scroll]');
    if (!root) return;
    root.querySelectorAll('[data-lpo-hiw-panel]').forEach(killPanelTriggers);
    root.dataset.lpoHiwScrollReady = 'false';
  });
})();
